export default "__VITE_ASSET__CHHAkkph__"